// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen {
  .meal-plan-recipe-servings-print {
    display: none;
  }
}

@media print {
  body {
    background-color: #fff !important;
    color: #000 !important;
  }

  /* Hide non-essential parts of the app layout */
  .left-panel,
  .back-to-top-button,
  .tour-buttons,
  .header-user-info {
    display: none !important;
  }

  /* Reset layout of remaining parts for printing */
  .App {
    display: block !important;
  }

  .right-panel {
    width: 100% !important;
    padding: 0 !important;
  }

  /* By default, hide all sections in the right panel when printing */
  .right-panel>.section {
    display: none !important;
  }

  /* Show only the section intended for printing */
  body.printing-meal-plan .meal-plan-print-section,
  body.printing-shopping-list .ingredients-print-section,
  body.printing-ingredient-list .ingredients-print-section {
    display: block !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  /* Hide specific interactive elements within the meal plan */
  .meal-plan-print-section .item-actions,
  .meal-plan-print-section .additional-items,
  /* Hides the input row for new items */
  .meal-plan-print-section .plus-button,
  .meal-plan-print-section .save-buttons-container,
  .meal-plan-print-section .days-servings-container,
  .meal-plan-print-section .print-hide,
  .meal-plan-print-section .meal-plan-recipe-servings-input {
    display: none !important;
  }

  /* Hide interactive elements when printing shopping list */
  body.printing-shopping-list .ingredient-list-panel,
  body.printing-shopping-list .shopping-list-panel .save-buttons-container,
  body.printing-shopping-list .ingredient-item input[type="checkbox"] {
    display: none !important;
  }

  /* Hide interactive elements when printing packing list */
  body.printing-ingredient-list .shopping-list-panel,
  body.printing-ingredient-list .ingredient-list-panel .save-buttons-container,
  body.printing-ingredient-list .ingredient-item input[type="checkbox"] {
    display: none !important;
  }

  body.printing-ingredient-list .ingredient-item.selected span {
    text-decoration: none !important;
    color: #000 !important;
  }

  /* Ensure lists and items are displayed correctly */
  .meal-plan-print-section ul,
  .meal-plan-print-section li,
  .ingredients-print-section ul,
  .ingredients-print-section li {
    background-color: transparent !important;
  }

  body.printing-shopping-list .shopping-list-panel,
  body.printing-ingredient-list .ingredient-list-panel {
    width: 100% !important;
    background-color: transparent !important;
    padding: 0 !important;
    border: none !important;
    flex: none !important;
  }

  .day-slot {
    border: 1px solid #ccc !important;
    padding: 5px !important;
  }

  .meal-plan-recipe,
  .day-row,
  .additional-item {
    page-break-inside: avoid;
  }

  .meal-plan-recipe-servings-print {
    display: block !important;
  }

  .material-icons {
    display: none !important;
  }

  body.printing-meal-plan .ingredients-container {
    display: none !important;
  }

  /* Two-column layout and larger font for lists */
  .shopping-list-panel ul,
  .ingredient-list-panel ul {
    column-count: 2 !important;
    column-gap: 2rem !important;
    width: 100% !important;
  }

  .shopping-list-panel li,
  .ingredient-list-panel li {
    font-size: 14pt !important;
    line-height: 1.4 !important;
    break-inside: avoid !important;
    page-break-inside: avoid !important;
    margin-bottom: 0.5rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/print.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,sBAAsB;EACxB;;EAEA,+CAA+C;EAC/C;;;;IAIE,wBAAwB;EAC1B;;EAEA,iDAAiD;EACjD;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA,mEAAmE;EACnE;IACE,wBAAwB;EAC1B;;EAEA,gDAAgD;EAChD;;;IAGE,yBAAyB;IACzB,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA,4DAA4D;EAC5D;;;;;;;;IAQE,wBAAwB;EAC1B;;EAEA,0DAA0D;EAC1D;;;IAGE,wBAAwB;EAC1B;;EAEA,yDAAyD;EACzD;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,gCAAgC;IAChC,sBAAsB;EACxB;;EAEA,mDAAmD;EACnD;;;;IAIE,wCAAwC;EAC1C;;EAEA;;IAEE,sBAAsB;IACtB,wCAAwC;IACxC,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,iCAAiC;IACjC,uBAAuB;EACzB;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,gDAAgD;EAChD;;IAEE,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;;IAEE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,mCAAmC;IACnC,gCAAgC;EAClC;AACF","sourcesContent":["@media screen {\n  .meal-plan-recipe-servings-print {\n    display: none;\n  }\n}\n\n@media print {\n  body {\n    background-color: #fff !important;\n    color: #000 !important;\n  }\n\n  /* Hide non-essential parts of the app layout */\n  .left-panel,\n  .back-to-top-button,\n  .tour-buttons,\n  .header-user-info {\n    display: none !important;\n  }\n\n  /* Reset layout of remaining parts for printing */\n  .App {\n    display: block !important;\n  }\n\n  .right-panel {\n    width: 100% !important;\n    padding: 0 !important;\n  }\n\n  /* By default, hide all sections in the right panel when printing */\n  .right-panel>.section {\n    display: none !important;\n  }\n\n  /* Show only the section intended for printing */\n  body.printing-meal-plan .meal-plan-print-section,\n  body.printing-shopping-list .ingredients-print-section,\n  body.printing-ingredient-list .ingredients-print-section {\n    display: block !important;\n    border: none !important;\n    box-shadow: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  /* Hide specific interactive elements within the meal plan */\n  .meal-plan-print-section .item-actions,\n  .meal-plan-print-section .additional-items,\n  /* Hides the input row for new items */\n  .meal-plan-print-section .plus-button,\n  .meal-plan-print-section .save-buttons-container,\n  .meal-plan-print-section .days-servings-container,\n  .meal-plan-print-section .print-hide,\n  .meal-plan-print-section .meal-plan-recipe-servings-input {\n    display: none !important;\n  }\n\n  /* Hide interactive elements when printing shopping list */\n  body.printing-shopping-list .ingredient-list-panel,\n  body.printing-shopping-list .shopping-list-panel .save-buttons-container,\n  body.printing-shopping-list .ingredient-item input[type=\"checkbox\"] {\n    display: none !important;\n  }\n\n  /* Hide interactive elements when printing packing list */\n  body.printing-ingredient-list .shopping-list-panel,\n  body.printing-ingredient-list .ingredient-list-panel .save-buttons-container,\n  body.printing-ingredient-list .ingredient-item input[type=\"checkbox\"] {\n    display: none !important;\n  }\n\n  body.printing-ingredient-list .ingredient-item.selected span {\n    text-decoration: none !important;\n    color: #000 !important;\n  }\n\n  /* Ensure lists and items are displayed correctly */\n  .meal-plan-print-section ul,\n  .meal-plan-print-section li,\n  .ingredients-print-section ul,\n  .ingredients-print-section li {\n    background-color: transparent !important;\n  }\n\n  body.printing-shopping-list .shopping-list-panel,\n  body.printing-ingredient-list .ingredient-list-panel {\n    width: 100% !important;\n    background-color: transparent !important;\n    padding: 0 !important;\n    border: none !important;\n    flex: none !important;\n  }\n\n  .day-slot {\n    border: 1px solid #ccc !important;\n    padding: 5px !important;\n  }\n\n  .meal-plan-recipe,\n  .day-row,\n  .additional-item {\n    page-break-inside: avoid;\n  }\n\n  .meal-plan-recipe-servings-print {\n    display: block !important;\n  }\n\n  .material-icons {\n    display: none !important;\n  }\n\n  body.printing-meal-plan .ingredients-container {\n    display: none !important;\n  }\n\n  /* Two-column layout and larger font for lists */\n  .shopping-list-panel ul,\n  .ingredient-list-panel ul {\n    column-count: 2 !important;\n    column-gap: 2rem !important;\n    width: 100% !important;\n  }\n\n  .shopping-list-panel li,\n  .ingredient-list-panel li {\n    font-size: 14pt !important;\n    line-height: 1.4 !important;\n    break-inside: avoid !important;\n    page-break-inside: avoid !important;\n    margin-bottom: 0.5rem !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
